export interface AuthUserInfo {
  displayName: string;
  authToken: string;
  firebaseToken: string;
  uid: string;
  phoneNumber: string;
  shoperId: string;
}

export class UserInfo
{
  public userId: string;
  public name: string;
  public email: string;
  public phoneNumber: string;
  public birthday: string;
  public gender: number;
  public address: string;
  public ageRangeId: number;
  public shopType: number;
  public shopName: string;
  public skinCareId: number;
  public communeId: string;
  public uid: string;
  public refId: string;
  public isFirstLogin :boolean;
}

export class QrCodeLoginRequest
{
  public code: string;
}

export class QrCodeLoginResponse
{
  public  errorMessage:string;
  public  phoneNumber:string;
  public  shortId:string;
  public  userId:string;
  public  needUpdate:boolean;
  public campaignId: number;
  public maxGiftPerUser: number;
}

export class OTPTransactionRequest
{
  public transactionId: string;
  public provider: string;
}